function PipingPanel(element) {
    this.panel = document.getElementById(element);
    this.set_items = {};
}

PipingPanel.prototype = {
    constructor: PipingPanel,

    getPanel: function() {
        var rendered = Mustache.render(this.panel.innerHTML, this.set_items);
        return rendered;
    },

    getNoPipingPanel: function() {
        var rendered = Mustache.render(this.panel.innerHTML);
        return rendered;
    },

    setPipingSetItems: function() {
        var piping_images = _.filter(ub.data.piping_images, function(image) {
            // Change Assets URL
            image.thumbnail = ub.utilities.changeAssetUrl(image.thumbnail);
            
            if (image.bp_name === ub.config.blockPattern && ub.config.option === image.block_pattern_option) {
                if (ub.funcs.is_pts_select_pant()) {
                    // Remove|OR Tunnel Piping in PTS SELECT PANT 
                    // This might be temporary.
                    if (image.piping_set !== "Tunnel Piping") {
                        return image;
                    }
                } else {
                    if ((ub.config.blockPattern === "PTS Select Set-In" || ub.config.blockPattern === "Select Set-In") && ub.config.option === "2 Button") {
                        if (image.piping_set !== "Center Piping") {
                            return image;
                        }
                    } else {
                        return image;
                    }
                }
            }
        });

        var colors = ColorPalette.funcs.getConfigurationPerTab("piping");

        var piping_types = PipingPanel.getPipingTypes();

        var piping_set_items = _.map(piping_types, function(piping_type) {
            var active_piping_set = PipingPanel.getActivePipingSet(piping_type);
            var piping_set = piping_type;

            if (active_piping_set !== "undefined") {
                piping_set = ub.funcs.getPipingSet(piping_type);
            }

            var sizes = ub.funcs.sortPipingSizes({items: piping_set});
            var colors = ub.funcs.getPipingColorArray(active_piping_set);

            var modifier = piping_type.toLowerCase().replace(/ /g, "-");

            return {
                sizes: sizes.items,
                colors: colors,
                type: piping_type,
                type_wo_left_prefix: piping_type.indexOf('Left') === 0 ? piping_type.replace("Left", "") : piping_type,
                modifier: modifier,
                enabled: active_piping_set.enabled
            };
        });

        this.set_items = {
            piping_set_items: piping_set_items,
            images: piping_images,
            colors: colors
        };
    }
};

/**
 * static properties and functions
 */
PipingPanel.tempColors = [];
PipingPanel.events = {
    is_init_events_called: 0,

    init: function() {
        if (PipingPanel.events.is_init_events_called === 0) {
            // Event For the Requested UI
            $(".modifier_main_container").on("click", ".piping-image .piping-image-button", PipingPanel.events.onClickPipingImage); 
            $(".modifier_main_container").on("click", ".richardson-piping-ui .piping-sizes-buttons", PipingPanel.events.onPipingSizeButtonClick);
            $(".modifier_main_container").on("click", ".richardson-piping-ui .piping-colors-buttons", PipingPanel.events.onPipingColorButtonClick);
            $(".modifier_main_container").on('click', '.colors .piping-color-layer-btn', PipingPanel.events.onClickPipingColorLayer);
            $(".modifier_main_container").on("click", ".richardson-piping-ui .piping-configuration-colors .piping-color-selector-button", PipingPanel.events.onChangePipingColor);

            PipingPanel.events.is_init_events_called = 1;
        }
    },

    onChangePipingColor: function() {
        $(".richardson-piping-ui .piping-configuration-colors .piping-color-selector-button.active-piping-color").find(".piping-check").remove();
        $(".richardson-piping-ui .piping-configuration-colors .piping-color-selector-button.active-piping-color").removeClass("active-piping-color");
        
        // Get Color Object
        var color_code = $(this).data("color-code");
        var _colorObj = ub.funcs.getColorByColorCode(color_code);

        var pipingLayerID = $(".richardson-piping-ui .colors .piping-color-layer-btn.uk-active").data("piping-layer");

        var active_size_type = $('.richardson-piping-ui .sizes .piping-sizes-buttons.uk-active').data('type');
        PipingPanel.applyPipingColor(active_size_type, pipingLayerID, _colorObj);

        $(this).html('<div class="cp-check-background piping-check"><span class="fa fa-check fa-1x cp-piping-check-medium"></span></div>');

        if (color_code === 'W'
            || color_code === 'Y'
            || color_code === 'CR'
            || color_code === 'S'
            || color_code === 'PK'
            || color_code === 'OP'
            || color_code === 'SG'
            || color_code === 'none'
        ) {
            $(this).html('<div class="cp-check-background piping-check"><span class="fa fa-check fa-1x cp-piping-check-medium cp-fc-black"></span></div>');
        }

        $(this).addClass('active-piping-color');

        // if (_.size(ub.data.logos) !== 0) {
        //     LogoPanel.utilities.reInitiateLogo();
        // }

        var pipingObject = _.find(ub.data.pipings, {name: active_size_type});
        // Get Piping Settings object
        var _pipingSettingsObject = ub.funcs.getPipingSettingsObject(pipingObject.set);

        PipingPanel.updatePipingWidth(_pipingSettingsObject);
    },

    onClickPipingImage: function() {
        PipingPanel.setInitialState();
        var piping_set = $(this).data("piping-set");
        var pipingObject = ub.funcs.getPipingSet(piping_set);
        var sizes = ub.funcs.sortPipingSizes({items: pipingObject});
        var active_piping_set = PipingPanel.getActivePipingSet(piping_set);
        var pipingSettingsObject = ub.funcs.getPipingSettingsObject(piping_set);
        var width = PipingPanel.calculateTotalWidth(pipingSettingsObject);

        // Render Sizes
        var _template = document.getElementById("m-piping-configuration-sizes").innerHTML;
        var _markup = Mustache.render(_template, {
            width: width,
            sizes: sizes.items
        });

        $(".modifier_main_container .piping-configuration-size").html("");
        $(".modifier_main_container .piping-configuration-size").html(_markup);

        $(".piping-image .piping-image-button.uk-active").removeClass("uk-active");
        $(this).addClass("uk-active");

        if (pipingSettingsObject.enabled === 1 && pipingSettingsObject.size !== "") {
            $(".richardson-piping-ui .piping-sizes-buttons[data-size='"+ pipingSettingsObject.size +"']").trigger("click");
        } else {
            $(".richardson-piping-ui .piping-sizes-buttons[data-size='none']").trigger("click");
        }

        if (ub.config.type === "lower") {
            if (piping_set === "Back Insert Piping") {
                $("div#left-side-toolbar .perspective .change-perspective-button[data-perspective='back']").trigger("click");
            }

            if (piping_set === "Left Pant Piping") {
                $("div#left-side-toolbar .perspective .change-perspective-button[data-perspective='left']").trigger("click");
            }
        }

        RichardsonOrderEditor.statusChecker(PipingPanel.disablePipingFunction, 500);
    },

    onClickPipingColorLayer: function() {
        var layer = $(this).data("piping-layer");
        var piping_type = $(".piping-image .piping-image-button.uk-active").data('piping-set');
        var pipingSettingsObject = ub.funcs.getPipingSettingsObject(piping_type);

        var colors = ColorPalette.funcs.getConfigurationPerTab("piping");
        var pipping_colors_element = document.getElementById("m-piping-configuration-colors");
        var render_piping_colors = Mustache.render(
            pipping_colors_element.innerHTML,
            {
                colors: colors,
            }
        );

        $(".richardson-piping-ui .piping-configuration-colors").html("");
        $(".richardson-piping-ui .piping-configuration-colors").html(render_piping_colors);

        $(".richardson-piping-ui .colors .piping-color-layer-btn.uk-active").removeClass("uk-active");
        $(this).addClass("uk-active")

        if (typeof pipingSettingsObject !== "undefined") {
            var _layer = _.find(pipingSettingsObject.layers, {layer: parseInt(layer)});
            if (typeof _layer !== "undefined") {
                $(".richardson-piping-ui .piping-configuration-colors .piping-color-selector-button[data-color-code='"+ _layer.colorCode +"']").trigger("click");
            }
        }

        RichardsonOrderEditor.statusChecker(function() {
            var parent = $(".richardson-piping-ui");
            $(".m-piping-color-container", parent).addClass("uk-disabled");
        }, 50);
    },

    onPipingSizeButtonClick: function() {
        var type = $(this).data('type');
        var size = $(this).data('size');
        var piping_type = $(".piping-image .piping-image-button.uk-active").data('piping-set');

        $(".piping-sizes-buttons.uk-active").removeClass("uk-active");
        $(this).addClass("uk-active");
        if (size === "none") {
            PipingPanel.disablePiping(piping_type)
            $(".richardson-piping-ui .piping-configuration-colors").html("");
            $(".richardson-piping-ui .piping-configuration-color-layer").html("");

            // if (typeof ub.data.logos !== "undefined") {
            //     LogoPanel.utilities.reInitiateLogo();
            // }

            $(".richardson-piping-ui span.piping-total-width").html("");
            $(".richardson-piping-ui span.piping-total-width").html('(Total Width = 0")');
            return;
        }

        var active_piping_set = PipingPanel.getActivePipingSet(piping_type);
        var pipingObject = _.find(ub.data.pipings, {name: type});
        var colorsMarkup =  ub.funcs.getPipingColorsNew(pipingObject);
        var lastColor = _.last(ub.funcs.getPipingColorArray(pipingObject));
        var pipingSettingsObject = ub.funcs.getPipingSettingsObject(active_piping_set.set);
        var matchingPipingObject;
        var matchingPipingSettingsObject;

        var name = pipingObject.name;
        var matchingName = "";

        ub.funcs.changePipingSize(pipingSettingsObject, pipingObject, size);

        /// Process Matching Object
        if (name.indexOf('Left') > -1) {
            matchingName = ub.funcs.getMatchingSide(name);
            matchingPipingObject = _.find(ub.data.pipings, {name: matchingName});
        }

        if (name.indexOf('Right') > -1) {
            matchingName = ub.funcs.getMatchingSide(name);
            matchingPipingObject = _.find(ub.data.pipings, {name: matchingName});
        }

        if (typeof matchingPipingObject !== 'undefined') {
            matchingPipingSettingsObject = ub.funcs.getPipingSettingsObject(matchingPipingObject.set);
            ub.funcs.changePipingSize(matchingPipingSettingsObject, matchingPipingObject, size);
            var width = PipingPanel.calculateTotalWidth(matchingPipingSettingsObject);
        }
        /// End Process Matching Object
        $(".richardson-piping-ui .piping-configuration-numbers-colors").html("")
        $(".richardson-piping-ui .piping-configuration-numbers-colors").html(colorsMarkup);

        // Force one color when going to 1/2
        if (ub.config.type === "lower") {
            if (type === "Back Insert Piping 1/2" || type === "Tunnel Piping 1/4" || type === "Tunnel Piping 1/2") {
                $('.richardson-piping-ui .piping-colors-buttons').first().click();
            } else {
                $('.richardson-piping-ui .piping-colors-buttons').last().click();
            }

            if (pipingSettingsObject.numberOfColors === 0) {
                $('.richardson-piping-ui .piping-colors-buttons[data-type="' + lastColor.name + '"]').click();
            } else {
                $('.richardson-piping-ui .piping-colors-buttons[data-value="' + pipingSettingsObject.numberOfColors + '"]').click();
            }
        } else {
            if (piping_type === "Neck Piping") {
                if (type === "Neck Piping 1/2") {
                    $('.richardson-piping-ui .piping-colors-buttons').first().click();
                } else {
                    $('.richardson-piping-ui .piping-colors-buttons').last().click();
                }
            } else {
                if (pipingSettingsObject.numberOfColors === 0) {
                    $('.richardson-piping-ui .piping-colors-buttons[data-type="' + lastColor.name + '"]').click();
                } else {
                    $('.richardson-piping-ui .piping-colors-buttons[data-value="' + pipingSettingsObject.numberOfColors + '"]').click();
                }
            }
        }

        // if (typeof ub.data.logos !== "undefined") {
        //     LogoPanel.utilities.reInitiateLogo();
        // }

        PipingPanel.updatePipingWidth(pipingSettingsObject);
    },

    onPipingColorButtonClick: function(e) {
        var active_size_type = $('.richardson-piping-ui .sizes .piping-sizes-buttons.uk-active').data('type');
        var size = $('.richardson-piping-ui .sizes .piping-sizes-buttons.uk-active').data("size");
        var value = $(this).data('value');

        $(".richardson-piping-ui .piping-colors-buttons.uk-active").removeClass("uk-active");
        $(this).addClass("uk-active");

        var piping_type = $(".piping-image .piping-image-button.uk-active").data('piping-set');
        var active_piping_set = PipingPanel.getActivePipingSet(piping_type);

        var pipingObject = _.find(ub.data.pipings, {name: active_size_type});

        var pipingSettingsObject = ub.funcs.getPipingSettingsObject(active_piping_set.set);
        var matchingPipingObject;
        var matchingPipingSettingsObject;

        var name = pipingObject.name;

        var colorPickerHtml    = ub.funcs.drawPipingColorPickers(pipingObject, value, pipingSettingsObject);
        var selectedColorArray  = ub.current_material.settings.team_colors;

        /// Process Matching Object
        if (name.indexOf('Left') > -1) {
            matchingName = ub.funcs.getMatchingSide(name);
            matchingPipingObject = _.find(ub.data.pipings, {name: matchingName});
        }

        if (name.indexOf('Right') > -1) {
            matchingName = ub.funcs.getMatchingSide(name);
            matchingPipingObject = _.find(ub.data.pipings, {name: matchingName});
        }

        if (typeof matchingPipingObject !== 'undefined') {
            matchingPipingSettingsObject = ub.funcs.getPipingSettingsObject(matchingPipingObject.set);
            ub.funcs.changePipingSize(matchingPipingSettingsObject, matchingPipingObject, size);
            var width = PipingPanel.calculateTotalWidth(matchingPipingSettingsObject);
        }
        /// End Process Matching Object

        var layerHTML = PipingPanel.renderLayer(value);
        $(".richardson-piping-ui .piping-configuration-color-layer").html("");
        $(".richardson-piping-ui .piping-configuration-color-layer").html(layerHTML);

        ub.funcs.initPipingColors(pipingObject, selectedColorArray[0]);
        ub.funcs.renderPipings(pipingObject, value);

        /// Process Matching Object
        if (typeof matchingPipingObject !== "undefined") {
            matchingPipingSettingsObject.numberOfColors = value;

            ub.funcs.initPipingColors(matchingPipingObject, selectedColorArray[0]);
            ub.funcs.renderPipings(matchingPipingObject, value);
            var width = PipingPanel.calculateTotalWidth(matchingPipingSettingsObject);
        }
        /// End Process Matching Object

        $(".richardson-piping-ui .piping-configuration-color-layer .piping-color-layer-btn").first().trigger("click");

        // if (typeof ub.data.logos !== "undefined") {
        //     LogoPanel.utilities.reInitiateLogo();
        // }
    },

    onShowPipingModal: function(e) {
        var piping_el = $(this).closest('.piping-item');
        var type = piping_el.data("piping-type");
        var modifier = piping_el.data("piping-modifier");
        var number_of_colors = $(".colors .piping-colors-buttons.uk-active", piping_el).data("value");

        var layerHTML = PipingPanel.renderLayer(number_of_colors);
        var _pipingSettingsObject = ub.funcs.getPipingSettingsObject(type);

        var layers = [];
        _.each(_pipingSettingsObject.layers, function(layer) {
            layers.push({
                layer_no: layer.layer,
                colorObject: layer.colorObj
            });
        });

        if (typeof _pipingSettingsObject !== "undefined") {
            PipingPanel.saveTempColors({
                name: type,
                layers: layers
            });
        }

        var image = ub.getThumbnailImage(ub.active_view + "_view");
        var layers = ub.current_material.settings.pipings[type].layers;

        $("#piping-preview").css({
            'background-image': "url("+ image +")"
        });

        $("#piping-change-color .piping-name").html("");
        $("#piping-change-color .piping-name").html(type);

        ub.data.current_piping = {
            type: type,
            modifier: modifier
        };

        // Render Mustache
        var colors = ColorPalette.funcs.getConfigurationPerTab("piping");
        var pipping_colors_element = document.getElementById("m-tab-piping-colors-uikit");
        var render_piping_colors = Mustache.render(
            pipping_colors_element.innerHTML,
            {
                modifier: modifier,
                colors: colors,
            }
        );

        // Render Pattern Color
        $("#color-piping-list .m-piping-color-container").html("");
        $("#color-piping-list .m-piping-color-container").html(render_piping_colors);

        $("ul#color-piping-nav-list").html("");
        $("ul#color-piping-nav-list").html(layerHTML);

        $("ul#color-piping-nav-list li.uk-active").removeClass("uk-active");
        $("ul#color-piping-nav-list li").first().addClass('uk-active');
        $("ul#color-piping-list li.uk-active").removeClass('uk-active');
        $("ul#color-piping-list li").first().addClass('uk-active');


        _.delay(function() {
            _.map(layers, function(index) {
                var selected_button_el = $('#color-piping-list li[data-piping-layer="' + index.layer + '"] .m-piping-color-container button.piping-color-selector-button[data-color-code="'+ index.colorCode + '"]');

                if (selected_button_el.length > 0)
                {
                    selected_button_el.html('<div class="cp-check-background piping-check"><span class="fa fa-check fa-1x cp-piping-check-medium"></span></div>');
                    if (index.colorCode === 'W'
                        || index.colorCode === 'Y'
                        || index.colorCode === 'CR'
                        || index.colorCode === 'S'
                        || index.colorCode === 'PK'
                        || index.colorCode === 'OP'
                        || index.colorCode === 'SG'
                        || index.colorCode === 'none'
                    ) {
                        selected_button_el.html('<div class="cp-check-background piping-check"><span class="fa fa-check fa-1x cp-piping-check-medium cp-fc-black"></span></div>');
                    }
                    selected_button_el.addClass('active-piping-color');
                }
            });
        }, 500);

        UIkit.modal("#piping-change-color").show();
    },

    onSelectPipingColor: function() {
        var active_piping_el = $("#piping-change-color ul#color-piping-nav-list li.uk-active");
        var pipingLayerID = active_piping_el.data("piping-layer");

        var selected_color = $("#color-piping-list li.uk-active .m-piping-color-container button.active-piping-color")
        selected_color.removeClass('active-piping-color');
        selected_color.find('.piping-check').remove();

        // Get Color Object
        var color_code = $(this).data("color-code");
        var _colorObj = ub.funcs.getColorByColorCode(color_code);

        // Get Piping Sets
        var modifier = $(this).data("modifier");

        var active_size_type = $('.piping-item[data-piping-modifier="'+ modifier +'"] .sizes .piping-sizes-buttons.uk-active').data('type');
        var pipingObject = _.find(ub.data.pipings, {name: active_size_type});
        var _name = pipingObject.name;

        // Get Piping Settings object
        var _pipingSettingsObject = ub.funcs.getPipingSettingsObject(pipingObject.set);

        // Change Piping Color
        ub.funcs.changePipingColor(_colorObj, pipingLayerID, pipingObject);
        PipingPanel.changeTempColor(pipingObject.set, pipingLayerID, _colorObj);

        // Matching Piping Object and Piping Setting Object
        var matchingPipingObject;
        var matchingPipingSettingsObject;

        if (_name.indexOf('Left') > -1) {
            matchingName = ub.funcs.getMatchingSide(_name);
            matchingPipingObject = _.find(ub.data.pipings, {name: matchingName});
        }

        if (_name.indexOf('Right') > -1) {
            matchingName = ub.funcs.getMatchingSide(_name);
            matchingPipingObject = _.find(ub.data.pipings, {_name: matchingName});
        }

        if (typeof matchingPipingObject !== 'undefined') {
            matchingPipingSettingsObject = ub.funcs.getPipingSettingsObject(matchingPipingObject.set);
            ub.funcs.changePipingColor(_colorObj, pipingLayerID, matchingPipingObject);
        }

        var image = ub.getThumbnailImage(ub.active_view + "_view");

        $("#piping-preview").css({
            'background-image': "url("+ image +")"
        });

        $(this).html('<div class="cp-check-background piping-check"><span class="fa fa-check fa-1x cp-piping-check-medium"></span></div>');

        if (color_code === 'W'
            || color_code === 'Y'
            || color_code === 'CR'
            || color_code === 'S'
            || color_code === 'PK'
            || color_code === 'OP'
            || color_code === 'SG'
            || color_code === 'none'
        ) {
            $(this).html('<div class="cp-check-background piping-check"><span class="fa fa-check fa-1x cp-piping-check-medium cp-fc-black"></span></div>');
        }

        $(this).addClass('active-piping-color');
    },

    onCancelEditPiping: function() {
        var type = ub.data.current_piping.type;
        var modifier = ub.data.current_piping.modifier;
        var pipingSettingsObject = ub.funcs.getPipingSettingsObject(type);

        if (typeof pipingSettingsObject !== "undefined") {
            PipingPanel.cancelPipingColor(modifier, pipingSettingsObject.layers);
        }

        UIkit.modal("#piping-change-color").hide();
    },

    onApplyPipingColor: function() {
        var type = ub.data.current_piping.type;
        var modifier = ub.data.current_piping.modifier;

        var temp = _.find(PipingPanel.tempColors, {name: type});
        if (typeof temp !== "undefined") {
            PipingPanel.applyPipingColor(modifier, temp.layers);
        }
        
        // if (typeof ub.data.logos !== "undefined") {
        //     LogoPanel.utilities.reInitiateLogo();
        // }

        UIkit.modal("#piping-change-color").hide();
    }
};

PipingPanel.setInitialState = function() {
    var piping_types = PipingPanel.getPipingTypes();
    _.map(piping_types, function(piping_type) {
        var piping_settings_object = ub.funcs.getPipingSettingsObject(piping_type);
        var activePiping = $(".richardson-piping-ui .piping-image .piping-image-button[data-piping-set='"+ piping_settings_object.set +"']")
        if (piping_settings_object.enabled === 1 && piping_settings_object.size !== "") {
            if (!activePiping.hasClass("selected")) {
                activePiping.addClass("selected");
            }
        } else {
            if (activePiping.hasClass("selected")) {
                activePiping.removeClass("selected");
            }
        }
    });
};

PipingPanel.getActivePipingSet = function(piping_type) {
    var active_piping_set = ub.current_material.settings.pipings[piping_type];
    if (active_piping_set !== "undefined") {
        var piping_sets = ub.funcs.getPipingSet(piping_type);

        if (piping_sets.length > 0) {
            var active_piping_sets = _.filter(piping_sets, {enabled: 1});

            active_piping_set = active_piping_sets.length > 0 ? _.first(active_piping_sets) : _.first(piping_sets);
        }
    }

    return active_piping_set;
};

PipingPanel.isValidToProcessPipings = function() {
    var is_valid = false;

    if (ub.funcs.isCurrentSport('Baseball') || ub.funcs.isCurrentSport('Fastpitch')) {
        if (_.size(ub.current_material.material.pipings) !== 0) {
            is_valid = true;
        }
    }

    return is_valid;
};

PipingPanel.getPipingTypes = function() {
    return ub.funcs.getPipingSets();
};


PipingPanel.removePiping = function(pipingSet) {
    _.each(ub.views, function (view) {
        var _viewStr = view + '_view';

        if (typeof ub.objects[_viewStr][pipingSet] !== 'undefined'){
            ub[_viewStr].removeChild(ub.objects[_viewStr][pipingSet]);
        }

        delete ub.objects[_viewStr][pipingSet];
    });

    if (typeof(ub.current_material.settings.pipings[pipingSet]) !== "undefined") {
        ub.current_material.settings.pipings[pipingSet].enabled = 0;
    }
}


PipingPanel.disablePiping = function(piping_type) {
    var color_container = $('.richardson-piping-ui .piping-item[data-piping-type="' + piping_type + '"]').find('.piping-color-modifier-container');

    if (color_container.length !== 0) {
        color_container.html("");
    }

    // Remove Piping
    PipingPanel.removePiping(piping_type);
    // Remove Matching Piping
    if (piping_type.indexOf('Left') === 0) {
        var matching_side = ub.funcs.getMatchingSide(piping_type);
        PipingPanel.removePiping(matching_side);
    }
}

PipingPanel.hasLeftSleeve1Inch = function() {
    var leftSleeve1inch = ub.funcs.getPipingSettingsObject("Left Sleeve Piping 1 inch Up");

    if (typeof leftSleeve1inch !== "undefined" && leftSleeve1inch.enabled !== 0) {
        return true;
    }

    return false;
}

PipingPanel.renderLayer = function(size) {
    var _html = '';
    _html += '<h6 uk-margin class="uk-margin-small-top uk-margin-small-bottom uk-text-bold uk-text-uppercase fc-dark">Choose colors</h6>';
    _html += '<div class="colors">';
    _html += '<div class="uk-grid-small grid-tiny uk-grid-match uk-text-center con-select con-toggle active-bgc-red" uk-grid>';
    _html += ''    
    for (var i = 0; i < size; i++) {
        var index = i + 1;
        _html += '<div class="uk-width-auto uk-width-expand@s">'
            _html += '<a class="uk-button uk-button-small uk-width-1-1 uk-button-default btn-selection-choice piping-color-layer-btn uk-text-capitalize" data-piping-layer="'+ index +'">Color '+ index +'</a>'
        _html += '</div> '
    }
    _html += '</div>'
    _html += '</div>'

    return _html;
}

PipingPanel.saveTempColors = function(data) {
    var find = _.find(PipingPanel.tempColors, {name: data.name});

    if (typeof find !== "undefined") {
        find.layers = data.layers;
    } else {
        PipingPanel.tempColors.push(data);
    }
}

PipingPanel.changeTempColor = function(type, layer, colorObject) {
    var temp = _.find(PipingPanel.tempColors, {name: type});

    if (typeof temp !== "undefined") {
        var layer = _.find(temp.layers, {layer_no: parseInt(layer)});
        if (typeof layer !== "undefined") {
            layer.colorObject = colorObject;
        }
    }
}


PipingPanel.applyPipingColor = function (active_size_type, layer_number, _colorObj) {
    var pipingObject = _.find(ub.data.pipings, {name: active_size_type});
    var _name = pipingObject.name;

    // Get Piping Settings object
    var _pipingSettingsObject = ub.funcs.getPipingSettingsObject(pipingObject.set);
    if (typeof _pipingSettingsObject !== "undefined") {
        ub.funcs.changePipingColor(_colorObj, layer_number, pipingObject);
        var _layer = _.find(_pipingSettingsObject.layers, {layer: parseInt(layer_number)});
        if (typeof _layer !== "undefined") {
            _layer.colorCode = _colorObj.color_code;
            _layer.colorObj = _colorObj;
        }

        var width = PipingPanel.calculateTotalWidth(_pipingSettingsObject);
    }


    // Matching Piping Object and Piping Setting Object
    var matchingPipingObject;
    var matchingPipingSettingsObject;

    if (_name.indexOf('Left') > -1) {
        matchingName = ub.funcs.getMatchingSide(_name);
        matchingPipingObject = _.find(ub.data.pipings, {name: matchingName});
    }

    if (_name.indexOf('Right') > -1) {
        matchingName = ub.funcs.getMatchingSide(_name);
        matchingPipingObject = _.find(ub.data.pipings, {_name: matchingName});
    }

    if (typeof matchingPipingObject !== 'undefined') {
        matchingPipingSettingsObject = ub.funcs.getPipingSettingsObject(matchingPipingObject.set);
        ub.funcs.changePipingColor(_colorObj, layer_number, matchingPipingObject);
        
        if (typeof matchingPipingSettingsObject !== "undefined")
        {
            var _matchingLayer = _.find(matchingPipingSettingsObject.layers, {layer: parseInt(layer_number)});
            if (typeof _matchingLayer !== "undefined") {
                _matchingLayer.colorCode = _colorObj.color_code;
                _matchingLayer.colorObj = _colorObj;
            }

            var width = PipingPanel.calculateTotalWidth(matchingPipingSettingsObject);
        }
    }
};

PipingPanel.cancelPipingColor = function(modifier, layers) {
    _.each(layers, function(layer, index) {
        var active_size_type = $('.piping-item[data-piping-modifier="'+ modifier +'"] .sizes .piping-sizes-buttons.uk-active').data('type');
        var pipingObject = _.find(ub.data.pipings, {name: active_size_type});
        var _name = pipingObject.name;

        var colorNumber = $('.piping-item[data-piping-modifier="'+ modifier +'"] .colors .piping-colors-buttons.uk-active').data("value");
        var i = index + 1;

        if (parseInt(colorNumber) < i) {
            return;
        }

        // Get Piping Settings object
        var _pipingSettingsObject = ub.funcs.getPipingSettingsObject(pipingObject.set);
        if (typeof _pipingSettingsObject !== "undefined") {
            // Change Piping Color
            ub.funcs.changePipingColor(layer.colorObj, layer.layer, pipingObject);
        }

        // Matching Piping Object and Piping Setting Object
        var matchingPipingObject;
        var matchingPipingSettingsObject;

        if (_name.indexOf('Left') > -1) {
            matchingName = ub.funcs.getMatchingSide(_name);
            matchingPipingObject = _.find(ub.data.pipings, {name: matchingName});
        }

        if (_name.indexOf('Right') > -1) {
            matchingName = ub.funcs.getMatchingSide(_name);
            matchingPipingObject = _.find(ub.data.pipings, {_name: matchingName});
        }

        if (typeof matchingPipingObject !== 'undefined') {
            ub.funcs.changePipingColor(layer.colorObj, layer.layer, matchingPipingObject);
        }
    });
}

PipingPanel.calculateTotalWidth = function(pipingSettingsObject) {
    var numberOfLayers = 0;
    _.map(pipingSettingsObject.layers, function(layer, index) {
        var total = index + 1;
        if (pipingSettingsObject.numberOfColors >= total) {
            if (layer.colorCode !== "none") {
                numberOfLayers += 1;
            }
        }
    })

    var size = eval(pipingSettingsObject.size) * numberOfLayers;
    
    if (pipingSettingsObject.size !== "1/2") {
        size = ub.utilities.decimalToFraction(size);
        if (size.top === 0) {
            size = 0;
        }
    }

    var total_width = numberOfLayers === 1 ? pipingSettingsObject.size : size;
    pipingSettingsObject.width = typeof total_width === "object" ? total_width.display : total_width;

    return pipingSettingsObject.width;
}

PipingPanel.updatePipingWidth = function(pipingSettingsObject) {
    var width = PipingPanel.calculateTotalWidth(pipingSettingsObject);
    $(".richardson-piping-ui span.piping-total-width").html("");
    $(".richardson-piping-ui span.piping-total-width").html('(Total Width = ' + width + '")');
}

PipingPanel.disablePipingFunction = function() {
    var parent = $(".richardson-piping-ui");

    $(".sizes", parent).addClass("uk-disabled");
    $(".m-piping-color-container", parent).addClass("uk-disabled");
}